/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import fetch from "../../../api-client";
import type { RequestConfig, ResponseErrorConfig } from "../../../api-client";
import type { PromptsControllerCreateMutationResponse, PromptsControllerCreate400, PromptsControllerCreate401, PromptsControllerCreate403 } from "../../models/promptsController/PromptsControllerCreate";

function getPromptsControllerCreateUrl() {
  const res = { method: 'POST', url: `/api/v1/prompts` as const }  
  return res
}

/**
 * @summary Create a new prompt
 * {@link /api/v1/prompts}
 */
export async function promptsControllerCreate(config: Partial<RequestConfig> & { client?: typeof fetch } = {}) {
  const { client: request = fetch, ...requestConfig } = config  
  
  const res = await request<PromptsControllerCreateMutationResponse, ResponseErrorConfig<PromptsControllerCreate400 | PromptsControllerCreate401 | PromptsControllerCreate403>, unknown>({ method : "POST", url : getPromptsControllerCreateUrl().url.toString(), ... requestConfig })  
  return res.data
}